import { useQuery } from '@apollo/client';

import {
  type CurrentAdvertiserContext,
  type GetTalentSearchUserContextQuery,
  type GetTalentSearchUserContextQueryVariables,
  TalentSearchClaim,
} from 'src/graphql/generated';
import { TALENT_SEARCH_CONTEXT_QUERY } from 'src/graphql/gql_queries';

import { useAccountContext } from './use-account-context';

export const useTalentSearchContext = () => {
  const { data: accountContext } = useAccountContext();
  const currentAdvertiser = accountContext?.currentAdvertiser as
    | CurrentAdvertiserContext
    | undefined;
  const hirerSeekWebId = currentAdvertiser?.seekId;

  const { data, loading, error } = useQuery<
    GetTalentSearchUserContextQuery,
    GetTalentSearchUserContextQueryVariables
  >(TALENT_SEARCH_CONTEXT_QUERY, {
    skip: !hirerSeekWebId,
    variables: {
      input: {
        advertiserId: Number(hirerSeekWebId),
      },
    },
  });

  const contractClaim = data?.talentSearchUserContextV2?.claims;
  const accountHasPremiumTalentSearch =
    contractClaim?.includes(TalentSearchClaim.CONNECTED_TALENT_SEARCH) ||
    contractClaim?.includes(TalentSearchClaim.PREMIUM_TALENT_SEARCH) ||
    false;

  return { loading, error, data, accountHasPremiumTalentSearch };
};
